export enum Views {
  InitialPage,
  InitialPageLst,
  ReportPage,
  AboutPage,
  HowItWorksPage,
  SkeletonPage,
  Login,
}
